<template>
    <div class="w-full px-4 md:p-6">
        <div
            class="bg-white flex-col justify-start items-center gap-6 inline-flex md:p-6 p-4 md:py-8 rounded-md">
            <HeaderIntro v-bind="HeaderIntroProps" />

            <div class="text-center w-full">
                <H2
                    class="text-[#e40032] text-center font-open !font-bold !text-[32px] mb-6">
                    U.P. {{ state.display_name }}
                </H2>
                <a
                    v-if="!isVirtual"
                    :href="state.maps_url"
                    target="_blank"
                    class="md:mb-8 mb-4 block w-full text-center">
                    <div
                        class="block w-full mx-auto max-w-[330px] text-center location-address cursor-pointer text-[18px]">
                        {{ formattedAddress }}
                    </div>
                </a>

                <div
                    v-if="isVirtual"
                    class="flex justify-center align-middle text-highlight mb-6">
                    <Icon
                        class="mr-2"
                        icon="video"
                        alt="Video icon" />
                    <span
                        ><strong>Virtual Consultation</strong> (link will be
                        sent via email)</span
                    >
                </div>
                <p
                    class="block md:mb-8 mb-6 underline text-[#121212] text-[16px]">
                    {{ formatDate(state.selected_date) }},
                    {{ dynamicTime.start_time }}
                </p>
                <div class="md:max-w-[360px] mx-auto w-full">
                    <div
                        class="md:static fixed w-full bottom-0 left-0 right-0 md:p-0 p-4 z-50 bg-white">
                        <button
                            id="add-to-calendar"
                            @click="addToCalendar"
                            class="w-full text-center h-[48px] bg-[#e40032] mx-auto action-btn flex items-center justify-center space-x-2 p-4 relative flex-1 self-stretch flex-grow-1 text-text-on-background rounded-md overflow-hidden">
                            <Icon
                                class="mr-2"
                                icon="calendar"
                                alt="U.P Copy Text" />
                            <span
                                class="text-wrapper relative var-font-family font-[--WEB-all-button-large-font-weight] text-[--colour-theme-text-text-on-background] var-line-height mt--1 w-fit whitespace-nowrap"
                                >Add to calendar</span
                            >
                        </button>
                    </div>
                    <NuxtLink
                        :to="state.maps_url"
                        target="_blank"
                        class="action-btn mt-4 h-[48px] flex mx-auto w-full items-center justify-center space-x-2 p-4 relative flex-1 self-stretch flex-grow-1 border-[#121212] border-2 cursor-pointer rounded-md overflow-hidden">
                        <Icon
                            v-if="showIcons"
                            class="mr-2"
                            icon="location-marker"
                            alt="Add to Calendar icon" />
                        <span
                            class="text-wrapper relative var-font-family font-[--WEB-all-button-large-font-weight] text-[#121212] var-line-height mt--1 w-fit whitespace-nowrap">
                            Get Directions
                        </span>
                    </NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { atcb_action } from 'add-to-calendar-button';
    import { formatDate, convertTo12Hour } from '@/helpers/dateFormats';
    import { useBookingStore } from '@/stores/booking';
    import { formatAddress } from '@/helpers/formatAddress';
    import { useStateStore } from '@/stores/state';
    import { trackOpenAILead } from '@/helpers/openaiAds';

    const { state: applicationState } = useStateStore();

    const bookingStore = useBookingStore();
    const { state } = bookingStore;
    const formattedAddress = computed(() => formatAddress(bookingStore.state.address));
    const isVirtual = state.is_online;

    onMounted(() => {
        trackOpenAILead();
    });

    const dynamicTime = computed(() => {
        const times = applicationState.is24HourFormat
            ? {
                  start_time: state.start_time,
                  end_time: state.end_time,
              }
            : {
                  start_time: convertTo12Hour(state.start_time),
                  end_time: convertTo12Hour(state.end_time),
              };

        return times;
    });

    const HeaderIntroProps = ref({
        title: `${state.first_name}, <span class="header-secondary">lets get started</span>`,
        titleTag: 'H1',
        body: 'We look forward to meeting with you and discussing your next steps to help you achieve your goals. ',
        bodyClasses: 'subheading',
    });

    const calendarConfig = computed(() => ({
        name: `Ultimate Performance Consultation at ${state.display_name}`,
        description: 'Consultation description and details.',
        startDate: state.selected_date,
        endDate: state.selected_date,
        startTime: state.start_time,
        endTime: state.end_time,
        options: ['Apple', 'Google', 'iCal', 'Yahoo'],
        timeZone: state.timezone,
    }));

    // Method to handle calendar button click
    const addToCalendar = () => {
        const button = document.getElementById('add-to-calendar');
        if (button) {
            atcb_action(calendarConfig.value, button);
        } else {
            console.error('Add to Calendar button not found');
        }
    };
</script>
